import React, { Component } from 'react';
import FavoriKur from './../components/favorikur';
import Bant from './../components/bant';
import Haberler from './../components/haberler';
import http from "./../services/httpService";
import config from "./../config.json";

class FavorilerSayfa extends Component {
    state = {  
        values: [],
        avalues: [],
        dvalues: [],
        banner:{}
    }

    componentDidMount(){
        this.setValues();
        this.interval = setInterval(() => this.setValues(), 2000);
        document.title = "Altınkaynak Şirketler Grubu - Canlı Favorilerim"
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    async setValues(){

        if(JSON.parse(localStorage.getItem('avalues')) !== null){
            this.setState({values : JSON.parse(localStorage.getItem('avalues')).concat(JSON.parse(localStorage.getItem('dvalues'))),avalues:JSON.parse(localStorage.getItem('avalues')),dvalues:JSON.parse(localStorage.getItem('dvalues')),banner:JSON.parse(localStorage.getItem('banner'))})
        }
        
        //var {data : avalues} =  await http.get(config.apiEndpoint + 'Gold');
        var {data : avalues} =  await http.get(config.restEndpoint + 'Gold.json');
        localStorage.setItem('avalues', JSON.stringify(avalues));
        //var {data : dvalues} =  await http.get(config.apiEndpoint + 'Currency');
        var {data : dvalues} = await http.get(config.restEndpoint + 'Currency.json');
        localStorage.setItem('dvalues', JSON.stringify(dvalues));
        var {data : banner} =  await http.get(config.apiEndpoint + 'Banner');
        localStorage.setItem('banner', JSON.stringify(banner));

        if(avalues !== null & dvalues !== null)
            this.setState({values : avalues.concat(dvalues),avalues,dvalues,banner})
    }

    showBanner = banner =>{
        if (banner !== null)
          return <a href={banner.Link} target="_blank" rel="noreferrer"><img className="banner" src={'https://www.altinkaynak.com/resources/livebanners/' + banner.Name} alt={banner.Name} /></a>
        else
          return ''
      }
      

    render() { 
        return <React.Fragment>
                <Bant dvalues={this.state.dvalues} avalues={this.state.avalues}/>
                <div className="row">
                    <div className="col-lg-8">
                        <div className="row">
                            <div className="col-lg-12">
                                <FavoriKur main={false} showdescription={false} header={'Favoriler'} values={this.state.values}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <Haberler header={'Haberler'} height={196} />
                            </div>
                            <div className="col-lg-12">
                                <div className="bannerbox">
                                    {this.showBanner(this.state.banner)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>;
    }
}
 
export default FavorilerSayfa;